<template>
    <div class="container" @keydown.enter="search">
        <el-input
            v-model="input.value"
            :placeholder="placeholder"
            class="input"
            autofocus />
        <el-button
            class="button"
            icon="el-icon-search"
            type="primary"
            @click="search"
            round
            :loading="loading.searchBox">
            Search
        </el-button>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    data() {
        return {
            value: '',
        };
    },
    props: {
        input: Object,
        placeholder: String,
        onSearch: Function,
    },
    computed: mapGetters(['loading']),
    methods: {
        ...mapMutations(['setLoading', 'unsetLoading']),
        async search() {
            if (this.input.value) {
                this.setLoading('searchBox');
                await this.onSearch(this.input.value);
                this.unsetLoading('searchBox');
            }
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.container > * + * {
    margin-left: 10px;
}
.input {
    font-size: 20px;
}
</style>